import Service from "../../Services";

const VenueHire = {
  namespaced: true,
  state: {
    form: {
      id: "",
      branch_id: "",
      name_th: "",
      name_en: "",
      description_en: "",
      description_th: "",
      slug_url: "",
      manual_url_th: "",
      manual_url_en: "",
      contact_email: "",
      contact_info: "",
      is_publish: true,
      youtube_url: "",
      slide_images: "",
    }
  },
  mutations: {
    GET_FORM: (state, res) => {
      state.form = res;
    },
    CLEAR_FORM_DATA: state => {
      state.form = {
        id: "",
        branch_id: "",
        name_th: "",
        name_en: "",
        description_en: "",
        description_th: "",
        slug_url: "",
        manual_url_th: "",
        manual_url_en: "",
        contact_email: "",
        contact_info: "",
        is_publish: true,
        youtube_url: "",
        slide_images: "",
      };
    },
    SET_SLIDE_IMAGE: (state, data) => {
      state.form.slide_images = [
        ...state.form.slide_images,
        {
          ...data
        }
      ];
    },
    REMOVE_SLIDE_IMAGE: (state, index) => {
      state.form.slide_images = state.form.slide_images.filter(
        (detail, itemIndex) => index !== itemIndex
      );
    }
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    getVenueHire({ commit }, { page, search, sort_date }) {
      return Service.VenueHireAPI.getVenueHire(page, search, sort_date);
    },
    // eslint-disable-next-line no-unused-vars
    showVenueHire({ commit }, id) {
      return Service.VenueHireAPI.showVenueHire(id);
    },
    // eslint-disable-next-line no-unused-vars
    saveVenueHire({ commit }, { id, data }) {
      if (id) {
        return Service.VenueHireAPI.updateVenueHire(id, data);
      } else {
        return Service.VenueHireAPI.createVenueHire(data);
      }
    },
    // eslint-disable-next-line no-unused-vars
    deleteVenueHire({ commit }, id) {
      return Service.VenueHireAPI.deleteVenueHire(id);
    },
    // eslint-disable-next-line no-unused-vars
    getAllVenueHire({ commit }) {
      return Service.VenueHireAPI.getVenueHireAll();
    },
    getVenueHireType({ commit }) {
      return Service.VenueHireAPI.getVenueHireType();
    },
    setFormVenueHire({ commit }, res) {
      commit("GET_FORM", res);
    },
    clearFormData({ commit }) {
      commit("CLEAR_FORM_DATA");
    },
    insertSlideImage({ commit }, data) {
      commit("SET_SLIDE_IMAGE", data);
    },
    removeSlideImage({ commit }, index) {
      commit("REMOVE_SLIDE_IMAGE", index);
    }
  }
};
export default VenueHire;
